import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";
import { CURRENCY_FRAGMENT } from "../../fragments/menu";

import type { Menus } from "../../types/menuTypes";
import type { UseOptions } from "../hookTypes"

const GET_MENUS = gql`
  query menus($restaurantId: ID!) {
    menus(restaurantId: $restaurantId) {
      id
      name
      description
      languages {
        position
        language
      }
      mainLanguage
      menuSections {
        id
        name
        position
        menuId
      }
      qrCode {
        id
        qrSvg
        data
      }
      ...CurrencyFragment
    }
  }
  ${CURRENCY_FRAGMENT}
`;

const useMenus = (id: string | number | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<Menus>(GET_MENUS, {
    variables: { restaurantId: String(id) },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });


  if (refetchOnMount && !loading) {
    refetch();
  }

  const menus = data?.menus;

  const refetchMenus = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    menus,
    loading,
    error: error as Error | null | undefined,
    refetchMenus,
  };
}

export default useMenus
